import React, { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ClipLoader } from "react-spinners";
import { isPublicPollPath } from "../routes/publicPollPaths";

const DashboardAppShell = lazy(() => import("./DashboardAppShell"));
const PublicPollRoutes = lazy(() => import("../routes/PublicPollRoutes"));

const LoadingScreen = () => (
  <div className="flex h-screen flex-col items-center justify-center text-center">
    <ClipLoader color={"#123abc"} loading size={50} />
  </div>
);

const AppNew = () => {
  const RoutesForRequest = isPublicPollPath(window.location.pathname)
    ? PublicPollRoutes
    : DashboardAppShell;

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingScreen />}>
          <RoutesForRequest />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default AppNew;
